<div id="current-month-billing-cycle-wrapper">
  <app-billing-cycle-display-card [billingCycle]="currentMonthBillingCycle$ | async"></app-billing-cycle-display-card>
</div>
